<template>
  <b-card>
    <FormView
      :data="$store.getters['rootCategory/detailData']"
      :fields="$store.getters['rootCategory/tableFields']"
      @load="loadData"
    />
  </b-card>
</template>

<script>
import FormView from '@/layouts/components/FormView.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    FormView,
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('rootCategory/getDetail', id)
    },
  },
}
</script>

<style scoped>

</style>
